'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce = require('../util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dispatch() {
  document.dispatchEvent(new CustomEvent('theme:resize', {
    bubbles: true
  }));
} /* eslint-env browser */


function resizeListener() {
  window.addEventListener('resize', (0, _debounce2.default)(function () {
    dispatch();
  }, 50));
}

exports.default = resizeListener;